import { render, staticRenderFns } from "./VHomeImgJumboCard.vue?vue&type=template&id=825d33ea&scoped=true&"
import script from "./VHomeImgJumboCard.vue?vue&type=script&lang=js&"
export * from "./VHomeImgJumboCard.vue?vue&type=script&lang=js&"
import style0 from "./VHomeImgJumboCard.vue?vue&type=style&index=0&id=825d33ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825d33ea",
  null
  
)

export default component.exports